import behaviourConstants from "@/constants/behaviourManagementConstants.js"
import { resolveCategoryColor } from "@/helpers/behaviourCoreValueForm.js"

/**
 * Reads the color hint from various row shapes (core value row,
 * positive behaviour row with nested `coreValue*` fields).
 * @param {Record<string, unknown> | null | undefined} item
 * @returns {{ hex: string, indicator: string }}
 */
function readColorFields(item) {
  const rawCategory = String(
    item?.category ?? item?.coreValueCategory ?? ""
  ).trim()
  const hex = String(
    item?.category_color ||
      item?.coreValueCategoryColor ||
      resolveCategoryColor(rawCategory) ||
      ""
  )
  const indicator = String(
    item?.indicator_color || item?.coreValueIndicatorColor || ""
  )
  return { hex, indicator }
}

/**
 * SCSS modifier class for the core value indicator dot.
 * @param {Record<string, unknown> | null | undefined} item
 * @returns {string}
 */
export function indicatorDotClassFor(item) {
  const { hex, indicator } = readColorFields(item)
  if (hex.startsWith("#")) {
    return ""
  }
  const fallback =
    indicator || behaviourConstants.CORE_VALUE_INDICATOR_COLOR_DEFAULT
  const safe =
    fallback === behaviourConstants.CORE_VALUE_INDICATOR_COLORS.BLUE
      ? "blue"
      : "green"
  return `behaviour-core-value-dot--${safe}`
}

/**
 * Inline style for hex-based core value indicators.
 * @param {Record<string, unknown> | null | undefined} item
 * @returns {{ backgroundColor: string } | undefined}
 */
export function indicatorDotStyleFor(item) {
  const { hex } = readColorFields(item)
  if (hex.startsWith("#")) {
    return { backgroundColor: hex }
  }
  return undefined
}

/**
 * Accessible label color name for the indicator dot.
 * @param {Record<string, unknown> | null | undefined} item
 * @returns {string}
 */
export function indicatorAriaColorFor(item) {
  const { indicator } = readColorFields(item)
  return indicator || behaviourConstants.CORE_VALUE_INDICATOR_COLOR_DEFAULT
}
